import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setGlobalTheme } from "services/theme/actions";
import ToastContainer from "@paylixecommerce/shared/components/toast";

// import loadable from "@loadable/component";

// const ToastContainer =
// 	loadable(() => import("@paylixecommerce/shared/components/toast"), {
// 		ssr: false
// 	}
// );


export default (ImportComponent) => (props) => {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setGlobalTheme(window.localStorage.getItem('theme') || 'light'));
	}, []);

	const changeTheme = () => {
		const theme = (window.localStorage.getItem("theme") || "light") === "light" ? "dark" : "light";
		dispatch(setGlobalTheme(theme));
	}

	return <>
		<ImportComponent {...props} changeTheme={changeTheme} />
		<ToastContainer />
	</>;
}
